export default {
  "content": "<path d=\"M18.667 1.84l-13.12 16A1.333 1.333 0 006.667 20h6.8l-4 8.707A1.44 1.44 0 0011.88 30.2L25 15.627a1.333 1.333 0 00-1.08-2.294h-7.107l4.347-10.12a1.454 1.454 0 00-2.493-1.373z\" fill=\"#A4A9B6\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};